<template>
  <DSPopover v-model:open="isOpen">
    <DSPopoverTrigger as-child>
      <slot />
    </DSPopoverTrigger>
    <DSPopoverContent
      align="end"
      class="w-80 p-0 overflow-hidden"
    >
      <PowerMode @close="isOpen = false" />
    </DSPopoverContent>
  </DSPopover>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { DSPopover, DSPopoverContent, DSPopoverTrigger } from '@ds'
import PowerMode from './PowerMode.vue'

const isOpen = ref(false)
</script>
